import merge from 'lodash/merge';
import {parseResponsiveProperty} from '@converdy/styles';

export function renderBaseFieldVars({
  fieldLabel,
  fieldBackground,
  fieldPlaceholder,
  fieldText,
  fieldBorder,
  fieldFocusBorder,
}) {
  let jss = {};

  merge(jss, {
    '--fieldLabel': fieldLabel,
    '--fieldBackground': fieldBackground,
    '--fieldPlaceholder': fieldPlaceholder,
    '--fieldText': fieldText,
    '--fieldBorder': fieldBorder,
    '--fieldFocusBorder': fieldFocusBorder,
  });

  return jss;
}

export default function baseFields(props) {
  const {variant, gutter} = props;

  let jss = {};

  merge(jss, {
    '&': {
      outline: 'none',
      marginBottom: '16px',
      appearance: 'none',
    },
    '& .field': {
      width: '100%',
    },
  });

  if (gutter) {
    merge(jss, {
      '&': {
        ...parseResponsiveProperty((c) => {
          return c
            ? {
                marginLeft: `-${c / 2}px`,
                marginRight: `-${c / 2}px`,
              }
            : {};
        }, gutter),
      },
      '& .field': {
        ...parseResponsiveProperty((c) => {
          return c
            ? {
                paddingLeft: `${c / 2}px`,
                paddingRight: `${c / 2}px`,
                marginBottom: `${c / 2}px`,
              }
            : {};
        }, gutter),
      },
    });
  }

  merge(jss, {
    ...renderBaseFieldVars(props),
    '--borderWidth': 'var(--themeBorderThickness)',
    '& .input': {
      outline: 'none',
      padding: '12px',
      marginBottom: '16px',
    },
    '& .error': {
      '--fieldBorder': 'var(--color-error)',
      '--fieldFocusBorder': 'var(--color-error)',
      '--borderWidth': '2px',
    },
    '& .error-message': {
      marginTop: '-12px',
      marginBottom: '16px',
      fontSize: '12px',
      display: 'block',
      color: 'var(--color-error)',
    },
    '& .field': {
      width: '100%',
    },
  });

  switch (variant) {
    case 'solid':
      merge(jss, {
        '& .baseLabel': {
          display: 'inline-block',
          color: 'var(--fieldLabel)',
          marginBottom: '10px',
        },
        '& .input': {
          backgroundColor: 'var(--fieldBackground)',
          borderColor: 'var(--fieldBorder)',
          color: 'var(--fieldText)',
          borderWidth: 'var(--borderWidth)',
          borderRadius: 'var(--themeShape)',
        },
        '& .input::placeholder': {
          color: 'var(--fieldPlaceholder)',
        },
        '& .input:focus': {
          borderColor: 'var(--fieldFocusBorder)',
        },
      });

      break;

    case 'outlined':
      merge(jss, {
        '& .baseLabel': {
          color: 'var(--fieldLabel)',
        },
        '& .input': {
          backgroundColor: 'var(--fieldBackground)',
          borderColor: 'var(--fieldBorder)',
          color: 'var(--fieldText)',
          borderWidth: 'var(--borderWidth)',
          borderRadius: 'var(--themeShape)',
        },
        '& .input::placeholder': {
          color: 'var(--fieldPlaceholder)',
        },
        '& .input:focus': {
          borderColor: 'var(--fieldFocusBorder)',
        },
      });

      break;
    case 'underlined':
      merge(jss, {
        '& .baseLabel': {
          color: 'var(--fieldLabel)',
        },
        '& .input': {
          backgroundColor: 'var(--fieldBackground)',
          borderColor: 'var(--fieldBorder)',
          color: 'var(--fieldText)',
          borderBottomWidth: 'var(--borderWidth)',
        },
        '& .input::placeholder': {
          color: 'var(--fieldPlaceholder)',
        },
        '& .input:focus': {
          borderColor: 'var(--fieldFocusBorder)',
        },
      });

      break;
  }

  return jss;
}
